import axios from 'axios';
import Config from '../config/config';
import Response from '../utils/response';
import PNotify from "pnotify/dist/es/PNotify";
const { baseUrl } = Config.axiosInstance;
const brand = {
    state: {
        isLoading: false,
        error: null,
        brands: []
    },
    reducers: {
        loading(state) {
            return {
                ...state,
                isLoading: true
            };
        },
        loadingOff(state) {
            return {
                ...state,
                isLoading: false
            };
        },
        fetchBrands(state, brandsData) {
            return {
                ...state,
                brands: brandsData
            };
        }
    },
    effects: {
        async getBrands() {
            try {
                const result = await axios.get(`${baseUrl}/api/brands`);
                this.fetchBrands(result.data);
            }
            catch (err) {
                PNotify.error({
                    title:"Error",
                    text:Response.error[400]
                });
            }
        },
        async deleteBrandByID(id) {
            try {
                await axios.delete(`${baseUrl}/api/brand/${id}`);
                this.getBrands();
            }
            catch (err) {
                PNotify.error({
                    title:"Error",
                    text:Response.error[400]
                });
            }
        },
        async addBrand(data) {
            try {
                axios.post(`${baseUrl}/api/addBrand`, data);
                this.getBrands();
            }
            catch (err) {
                PNotify.error({
                    title:"Error",
                    text:Response.error[400]
                });
            }
        },
        async editBrand(data) {
            try {
                axios.put(`${baseUrl}/api/updateBrand`, data);
                this.getBrands();
            }
            catch (err) {
                PNotify.error({
                    title:"Error",
                    text:Response.error[400]
                });
            }
        },
        async updateBrandStatus(data) {
            try {
                axios.put(`${baseUrl}/api/brandStatus`, data);
            }
            catch (err) {
                PNotify.error({
                    title:"Error",
                    text:Response.error[400]
                });
            }
        }
    }
};
export default brand;